// Cliente do waba-api. O cookie ss_session é só de agentes.revendai.com, então
// a waba é falada na MESMA origem: o Traefik repassa agentes.revendai.com/waba-api/*
// pra waba. O waba aceita o cookie do portal em require_api_auth
// (apps/waba/auth.py) e devolve só as conexões da conta.
export const WABA_BASE = import.meta.env.VITE_WABA_BASE ?? "/waba-api";

async function request<T>(path: string, init: RequestInit = {}): Promise<T> {
  const res = await fetch(`${WABA_BASE}${path}`, {
    ...init,
    credentials: "include",
    // X-SS-Portal: o waba ignora o carmillion_session (mesmo domínio .revendai.com)
    // e autentica SÓ pelo ss_session — senão um Admin logado no Valquiria veria tudo.
    headers: { "Content-Type": "application/json", "X-SS-Portal": "1", ...init.headers },
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw Object.assign(new Error(body.detail ?? res.statusText), { status: res.status, payload: body });
  }
  if (res.status === 204) return undefined as T;
  return res.json();
}

/** Texto legível do erro: `detail` pode ser string, objeto da Meta ({meta_message, error}) ou lista (422). */
export function errorText(err: any, fallback: string): string {
  const d = err?.payload?.detail;
  if (typeof d === "string") return d;
  if (d && typeof d === "object" && !Array.isArray(d)) return d.meta_message || d.error || JSON.stringify(d);
  return fallback;
}

export const wabaApi = {
  get: <T>(path: string) => request<T>(path),
  post: <T>(path: string, data?: unknown) => request<T>(path, { method: "POST", body: data ? JSON.stringify(data) : undefined }),
  put: <T>(path: string, data?: unknown) => request<T>(path, { method: "PUT", body: data ? JSON.stringify(data) : undefined }),
  patch: <T>(path: string, data?: unknown) => request<T>(path, { method: "PATCH", body: data ? JSON.stringify(data) : undefined }),
  delete: <T>(path: string) => request<T>(path, { method: "DELETE" }),
};

export interface Connection {
  id: string; name: string; status: string;
  phone_number_id: string | null; phone_number: string | null; display_name: string | null;
  ig_user_id: string | null; ig_username: string | null;
  messenger_active: boolean; page_name: string | null;
  claimed_by_agent_id: string | null;
  typing_indicator: boolean; auto_mark_read: boolean; auto_split_text: boolean;
  meta_disconnected_at: string | null;
  email_address: string | null;
  olx_account_name: string | null; olx_account_email: string | null; olx_status: string | null;  // connected | reconnect
  meli_nickname: string | null; meli_status: string | null;  // connected | reconnect
}
export type ChannelType = "waba" | "instagram" | "messenger";
export type ChannelBindings = Record<ChannelType, string | null>;
